import { User } from './model';

export interface IActionSubtype {
    id: number;
    name: string;
}

export interface IAction {
    id: number;
    createdAt?: Date;
    allocatedTo: User;
    createdBy: User;
    customer: User;
    actionType: number;
    actionTypeName: string;
    actionTypeLabel: string;
    actionTypeColour?: string;
    title: string;
    description: string;
    status: { id: number; name: string };
    source: string;
    contactMessageId: string;
    query?: string;
    subject?: string;
    subtypeId: number;
    subtypeName?: string;
    completionTime: Date;
    resolution?: string;
    taggedAdminsIds?: string[];
    products?: number[];
    phoneOptional?: string;
    labelIds: string[];
}

export type IActionFormData = {
    id?: number;
    text: string;
    title?: string;
    actionType: string;
    allocatedTo?: string;
    customerId?: string;
    subtypeId?: number;
};

export enum ActionTypeLabel {
    ENQ = 'ENQ',
    CALL_REQ = 'CALL REQ',
    AC_QUER = 'AC QUER',
    ORD_QUER = 'ORD QUER',
    NEW_ENQ = 'NEW ENQ',
}
